// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"a80771da","3091":"a80771da","4577":"a80771da","5472":"a80771da","8153":"a80771da"}[chunkId] + ".chunk.css";
};